import { Component, input } from '@angular/core';

/**
 * The panel every screen is built from. Screens used to write `class="card"`,
 * a class defined nowhere, so each one ended up with its own chrome.
 */
@Component({
    selector: 'app-surface',
    template: `
        @if (heading() || description()) {
            <header class="surface__header">
                <div class="surface__heading">
                    @if (heading()) {
                        <h2 class="surface__title">{{ heading() }}</h2>
                    }
                    @if (description()) {
                        <p class="surface__description">{{ description() }}</p>
                    }
                </div>

                <ng-content select="[surfaceActions]" />
            </header>
        }

        <div class="surface__body" [class.surface__body--flush]="flush()">
            <ng-content />
        </div>
    `,
    styles: `
        :host {
            display: block;
            background: var(--p-content-background);
            border: 1px solid var(--p-content-border-color);
            border-radius: 0.75rem;
            overflow: hidden;
        }

        .surface__header {
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            gap: 1rem;
            padding: 1rem 1.25rem;
            border-bottom: 1px solid var(--p-content-border-color);
        }

        .surface__heading {
            display: flex;
            flex-direction: column;
            gap: 0.25rem;
            min-width: 0;
        }

        .surface__title {
            margin: 0;
        }

        .surface__description {
            margin: 0;
            color: var(--p-text-muted-color);
            font-size: 0.75rem;
        }

        .surface__body {
            padding: 1.25rem;
        }

        .surface__body--flush {
            padding: 0;
            /* Wide tables scroll inside the panel instead of being clipped by its rounded corners. */
            overflow-x: auto;
        }
    `
})
export class SurfaceComponent {
    readonly heading = input('');
    readonly description = input('');
    /** Tables fill the panel edge to edge; forms and prose keep the padding. */
    readonly flush = input(false);
}
